import { useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";

export const HARVEST_PRINT_ROOT_ID = "harvest-label-print-root";
export const HARVEST_PRINT_BODY_CLASS = "harvest-print-active";

/**
 * Print-only container mounted directly under <body>. While it is mounted,
 * print CSS (index.css) removes every other body child from the layout, so
 * only these labels reach the paper: one label per page, no blank pages.
 * Hidden on screen.
 */
export function HarvestLabelPrintRoot({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.body.classList.add(HARVEST_PRINT_BODY_CLASS);
    return () => document.body.classList.remove(HARVEST_PRINT_BODY_CLASS);
  }, []);

  return createPortal(
    <div id={HARVEST_PRINT_ROOT_ID} aria-hidden="true">
      {children}
    </div>,
    document.body,
  );
}

/** One label = one printed page (the last one has no trailing page break). */
export function HarvestPrintLabelPage({ children }: { children: ReactNode }) {
  return <div className="harvest-print-label">{children}</div>;
}
